<template>
	<div
		class="ms-cell-editor"
		:style="{
			width: col.widthImportant ? `${col.widthImportant}px !important` : ``,
		}"
	>
		<div
			v-show="!isSelected || readOnly"
			class="flex-center"
			:class="{
				'edit-disabled': readOnly,
				'ms-editor-text': editable,
				'editor-input isValid': cellErrorProvider.isValid,
			}"
		>
			<div class="editor-display">
				<span>{{
					dataRow[col.dataField]
						| formatData({ formatType: col.formatType, enumName: col.enumName })
				}}</span
				><span v-if="dataRow.required == true" style="color: red">*</span>
			</div>

			<div
				class="icon-input float-right"
				v-tooltip="{ content: cellErrorProvider.message, classes: 'error' }"
				v-if="cellErrorProvider.isValid"
			>
				<div class="mi mi-24 mi-red-tick"></div>
			</div>
		</div>
		<div
			class="ms-editor w-full h-full"
			ref="editor"
			v-show="isSelected && !readOnly && editable"
			:class="{
				'edit-disabled': readOnly,
				'ms-editor-text': editable,
				'editor-input isValid pos-relative': cellErrorProvider.isValid,
			}"
			:style="{
				width: col.widthImportant ? `${col.widthImportant}px !important` : ``,
			}"
		>
			<div
				class="icon-cell-error-provider"
				v-tooltip="{ content: cellErrorProvider.message, classes: 'error' }"
				v-if="cellErrorProvider.isValid"
			>
				<div class="mi mi-24 mi-red-tick"></div>
			</div>
		</div>
	</div>
</template>
<script>
import msInput from '@/components/msinput/msInput.vue';
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
import Vue from 'vue';
import { setTimeout } from 'timers';
export default {
	name: 'msCellInputV2',
	extends: msBaseComponent,
	props: {
		col: {},
		dataRow: {},
		rowIndex: {
			default: 0,
			type: Number,
		},
		colIndex: {
			default: 0,
			type: Number,
		},
		//Thuộc tính để cấu hình cho phép sửa trên grid hay không
		editable: {
			default: true,
			type: Boolean,
		},
		rowSelected: {
			default: null,
		},
		isBlurAction: {
			default: true,
			type: Boolean,
		},
		isCustomValidate: {
			default: true,
			type: Boolean,
		},
	},
	components: {
		msInput,
	},
	computed: {
		readOnly() {
			const me = this;
			if (!me.editable) {
				return true;
			}
			if (me.col && typeof me.col.readOnly == 'function') {
				return me.col.readOnly(me.dataRow);
			} else {
				return me.col.readOnly;
			}
		},
	},
	mounted() {
		const me = this;
		let watchName = 'dataRow.' + me.col.dataField;
		me.$watch(watchName, function (newVal, oldVal) {
			me.validateCell();
		});
	},
	data() {
		return {
			isSelected: false,
			cellErrorProvider: {},
		};
	},
	watch: {
		isSelected: {
			handler(newVal, oldVal) {
				const me = this;
				if (newVal == false) {
					if (me.col.__editor) {
						if (me.col.__editor.errorProvider) {
							me.col.__editor.errorProvider = {};
						}
					}
					me.$nextTick(() => {
						me.validateCell();
					});
				} else {
					if (me.$el) {
						let content = me.$el.closest('.ms-content--table');
						if (content) {
							if (
								me.$el.getBoundingClientRect().right >=
								content.getBoundingClientRect().right
							) {
								content.scrollLeft += me.$el.getBoundingClientRect().x - 20;
							}
						}
					}
				}
				me.$set(me.dataRow, 'isSelected', newVal);
			},
		},
		'col.rules': {
			handler(newVal, oldVal) {
				const me = this;
				if (!newVal) {
					me.$nextTick(() => {
						me.validateCell();
					});
				}
			},
		},
	},
	methods: {
		validateComponent() {
			const me = this;
			if (!me.readOnly) {
				let col = me.col,
					rulesValidate = null,
					ret = false;
				let rules = col.rules;
				if (col.rules && typeof col.rules == 'function') {
					rules = col.rules(me.dataRow);
				}

				// Check valid theo cột dữ liệu trên dòng
				if (col.validBy) {
					let status = me.dataRow[col.validBy];
					if (!status) {
						return;
					}
				}

				if (rules) {
					let listRules = rules.split('|');
					for (let i = 0; i < listRules.length; i++) {
						ret = !me.validateRule(
							listRules[i],
							me.dataRow[col.dataField],
							col.__editor
						);
						if (ret) {
							rulesValidate = listRules[i];
							break;
						}
					}
					me.setValid(ret, rulesValidate);
				} else {
					if (me.cellErrorProvider && me.cellErrorProvider.rules == 'custom') {
					} else {
						me.cellErrorProvider = {};
					}
				}
			}
		},
		customValidate() {
			const me = this;
		},
		//Hàm validate trên từng cell
		validateCell() {
			const me = this;
			me.validateComponent();
			me.customValidate();
		},
		setValid(ret, rulesValidate, message) {
			const me = this;
			if (ret) {
				if (message) {
					me.cellErrorProvider.message = message;
				} else if (me.$t('i18nValidate').messages[rulesValidate]) {
					me.cellErrorProvider.message = me
						.$t('i18nValidate')
						.messages[rulesValidate](me.col.title);
				}
				me.$set(me.cellErrorProvider, 'isValid', true);
				me.cellErrorProvider.rules = rulesValidate;
				me.cellErrorProvider.element = me;
			} else {
				me.cellErrorProvider = {};
			}
		},

		//Khởi tạo editor
		//Created by LTDAT(17.06.2020)
		createdEditor() {
			const me = this;
			let editorControl = me.getEditorControl(),
				col = me.col,
				editorExtend = Vue.extend(editorControl),
				editorProperty = me.getEditorProperty(),
				instance = new editorExtend(editorProperty);
			instance.vm = instance.$mount();
			instance.$cell = me;
			//Định nghĩa thêm field sau dùng cho phân biệt các editor
			instance.$componentId = me.$ms.commonFunc.generateUUID();
			instance.$rowIndex = me.rowIndex;
			col.__editor = instance;
			me.addHandler(instance);
			return instance;
		},
		//Điều hướng cho sự kiện change
		changeHandler(value) {
			const me = this;
			let metaData = {
				dataRow: me.dataRow,
				column: me.col,
				newValue: value,
				oldValue: me.dataRow[me.col.dataField],
				cell: me,
			};

			me.$emit('change', metaData);
		},
		//Hàm xử lý sự kiện editor input
		inputHandler(value) {
			const me = this;
			let dataRow = me.dataRow,
				col = me.col;
			me.$set(dataRow, col.dataField, value);
			// dataRow[col.dataField] = value;
		},

		//Hàm xử lý sự kiện editor input
		blurHandler(value) {
			const me = this;
			let metaData = {
				dataRow: me.dataRow,
				column: me.col,
				newValue: value,
				oldValue: me.dataRow[me.col.dataField],
				cell: me,
			};
			me.$emit('blur', metaData);
		},

		addHandler(editor) {
			const me = this;
			editor.$cell = editor.$cell || me;
			editor.$on('input', (...args) => {
				if (editor.$cell) {
					editor.$cell.inputHandler(...args);
				}
			});
			editor.$on('change', (...args) => {
				if (editor.$cell) {
					editor.$cell.changeHandler(...args);
				}
			});
			if (me.isBlurAction) {
				editor.$on('blur', (...args) => {
					if (editor.$cell) {
						editor.$cell.blurHandler(...args);
					}
				});
			}
			me.addCustomHandler(editor);
		},
		//Các loại control khác có event có thể Overide hàm này
		//Created by LTDAT(18.06.2020)
		addCustomHandler(editor) {},
		//Lấy loại control
		//Created by LTDAT(17.06.2020)
		getEditorControl() {
			return msInput;
		},
		//Lấy thuộc tính truyền vào trong editor
		//Created by LTDAT(17.06.2020)
		getEditorProperty() {
			const me = this;
			let col = me.col;
			if (me.customEditProperty && typeof me.customEditProperty == 'function') {
				me.customEditProperty(col.editorProperty);
			}
			return col.editorProperty;
		},
		//Sự kiện click vào cell editor
		cellSelected() {
			const me = this;
			let col = me.col,
				editor = col.__editor;
			me.isSelected = true;
			if (!editor && me.$refs.editor) {
				editor = me.createdEditor();
			}
			if (editor) {
				editor.$cell = me;
				me.beforeEdit(editor);
				if (me.$refs.editor) {
					me.$refs.editor.appendChild(editor.$el);
					me.focusEditor(editor);
				}
			}
		},
		//Focus vào editor
		focusEditor(editor) {
			const me = this;
			let input = this.$refs.editor.querySelector('input,textarea');
			setTimeout(() => {
				if (input) {
					input.focus();
					input.select();
				}
			}, 100);
		},
		//Hàm xử lý trước khi edit reset lại các giá trị trong editor cũ
		//Created by LTDAT(17.06.2020)
		beforeEdit(editor) {
			const me = this;
			let dataRow = me.dataRow,
				col = me.col;
			setTimeout(() => {
				if (editor) {
					me.customBeforeEdit();
					if (typeof editor.reset === 'function') {
						editor.reset();
					}
					if (typeof editor.setValue === 'function') {
						editor.setValue(dataRow[col.dataField]);
					}
					if (
						editor.applyValidate &&
						typeof editor.applyValidate == 'function'
					) {
						me.$nextTick(() => {
							editor.applyValidate(me.cellErrorProvider.message);
						});
					}
				}
			});
			me.$emit('rowSelected', me.dataRow);
		},
		customBeforeEdit() {},

		//remove cell selected
		cancelCellSelected() {
			const me = this;
			let col = me.col,
				editor = col.__editor;
			me.isSelected = false;
			if (!editor && me.$refs.editor) {
				editor = me.createdEditor();
			}
			if (editor) {
				editor.$cell = me;
				me.beforeEdit(editor);
				if (me.$refs.editor) {
					me.$refs.editor.appendChild(editor.$el);
					me.focusEditor(editor);
				}
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.editor-display {
	padding: 6px 8px;
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 50px;
	overflow: hidden;
}
.mi-icon-error {
	margin-right: 8px;
}
.icon-cell-error-provider {
}
.editor-input {
	width: initial;
	height: initial;
	position: relative;
	/deep/.ms-input {
		&:focus-within {
			border: none;
			box-shadow: none;
		}
		&:hover {
			border: none;
			box-shadow: none;
		}
	}
	.icon-cell-error-provider {
		position: absolute;
		right: 10px;
	}
}
</style>
